import { Button, Input, CommonCalendar } from "components"
import { useState } from "react"
import "./style/style.css"
import { Box } from "theme-ui"
import { subMonths, addMonths, format, startOfMonth } from "date-fns"

import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

export const Calendar = () => {
 const navigate = useNavigate()
  // language translator
  const { t } = useTranslation("translation")
 const today = new Date()
 const [currentMonth, setCurrentMonth] = useState(startOfMonth(today))
 const [previousMonth, setPreviousMonth] = useState(startOfMonth(subMonths(currentMonth, 1)))
 const [nextMonth, setNextMonth] = useState(startOfMonth(addMonths(currentMonth, 1)))

 const [selectedMonth, setSelectedMonth] = useState(format(currentMonth, "MMMM"))
 const months = Array.from({ length: 12 }, (_, index) =>
  format(addMonths(currentMonth, index), "MMMM"),
 )

 const [state, setState] = useState([
  {
   startDate: currentMonth,
   endDate: currentMonth,
   key: "selection",
  },
 ])

 const handlePreviousMonth = () => {
  const newCurrentMonth = subMonths(currentMonth, 1)
  setCurrentMonth(newCurrentMonth)
  setPreviousMonth(subMonths(newCurrentMonth, 1))
  setNextMonth(addMonths(newCurrentMonth, 1))
  setSelectedMonth(format(newCurrentMonth, "MMMM"))
  setState([
   {
    startDate: newCurrentMonth,
    endDate: newCurrentMonth,
    key: "selection",
   },
  ])
 }

 const handleNextMonth = () => {
  const newCurrentMonth = addMonths(currentMonth, 1)
  setCurrentMonth(newCurrentMonth)
  setPreviousMonth(subMonths(newCurrentMonth, 1))
  setNextMonth(addMonths(newCurrentMonth, 1))
  setSelectedMonth(format(newCurrentMonth, "MMMM"))
  setState([
   {
    startDate: newCurrentMonth,
    endDate: newCurrentMonth,
    key: "selection",
   },
  ])
 }

 const handleMonthChange = (e: any) => {
  const selectedMonthDate = addMonths(currentMonth, months.indexOf(e.target.value))
  setCurrentMonth(selectedMonthDate)
  setPreviousMonth(subMonths(selectedMonthDate, 1))
  setNextMonth(addMonths(selectedMonthDate, 1))
  setSelectedMonth(e.target.value)
  setState([
   {
    startDate: selectedMonthDate,
    endDate: selectedMonthDate,
    key: "selection",
   },
  ])
 }

 const handleClick = () => {
  if (state[0].startDate && state[0].endDate) {
   navigate(
    `/site-plan-devices?begin_date=${new Date(
     state[0].startDate,
    ).toISOString()}&end_time=${new Date(state[0].endDate).toISOString()}`,
   )
  }
 }

 return (
  <div>
   <div className="w-[96%] mt-3.5 mx-auto lg:mt-10">
    <Box className="flex flex-col px-4 pt-4 pb-4 justify-between lg:flex-row" bg="highlight">
   
     <h1 className="font-semibold">{t("signalSchedule")}</h1>
     <div className="flex w-full lg:w-[35%]">
      <div className="w-[100%]">
       <Button color={"white"} size={"lg"}>
      {t("graphic")}
       </Button>
      </div>
      <div className="w-[100%] mx-2">
       <Button size={"lg"}>{t("analysis")}</Button>
      </div>
      <div className="w-[100%]">
       <Button color={"white"} size={"lg"}>
      {t("download")}
       </Button>
      </div>
     </div>
    </Box>
   </div>

   <div className="relative w-[96%] mx-auto">
    <Box bg="highlight" className="">
     <div className="duration absolute inset-0 flex flex-col justify-between w-[35%] left-6 top-5 lg:flex-row">
      <h1 className="mb-2 lg:mb-0">{t("beginning")}:</h1>
      <h1 className="endDate">{t("end")}:</h1>
     </div>

     <div className="typeBtnMain absolute right-[28px] w-[96%] top-[20px] flex flex-col lg:w-[30%]">
      <Input
       type="text"
       placeholder="Sum of green times"
       label={t("type")}
       className="typeBtn py-[13px] outline-none pl-2 mt-1 text-xs button-shadow"
      />
     </div>

     <Box bg="highlight">
      <div className="relative top-[99px] flex flex-col justify-between items-center carryBtnMain mb-6 w-[90%] mx-auto inset-0 z-0 lg:flex-row">
       <h1 className="text-xs lg:text-sm">
        Some other information about these fields to clear the user to fill them*
       </h1>
       <div className="flex justify-end carryBtn">
        <Button size={"lg"} onClick={handleClick}>
       {t("carryOut")}
        </Button>
       </div>
      </div>
     </Box>
     <Box
      className="bg- py-1 lg:py-5 absolute top-[150px] right-0 left-0 boxTransparent"
      bg="background"
     ></Box>

     <select
      className="text-black outline-none cursor-pointer absolute top-[213px] monthBtn right-24 py-1 px-4 rounded border-gray border"
      value={selectedMonth}
      onChange={handleMonthChange}
     >
      {months.map((month) => (
       <option key={month} value={month}>
        {month}
       </option>
      ))}
     </select>

     <div className="absolute top-[220px] left-[25%] w-fit preBtn flex items-center justify-center ">
      <button className="text-sm" onClick={handlePreviousMonth}>
     {t("previous")}
      </button>
     </div>

     <div className="absolute top-[220px] right-[28%] w-fit nextBtn flex items-center justify-center ">
      <button className="text-sm" onClick={handleNextMonth}>
    {t("next")}
      </button>
     </div>
     <div className="absolute top-[215px] left-[33%] monthChangeBtn flex justify-center w-[34%]">
      <div className="bg-white py-1 rounded border-gray border text-[10px] lg:text-sm w-[32%] text-center text-black px-2 lg:px-4">
       {format(previousMonth, "MMMM ")}
      </div>
      <div className="bg-golden py-1 border-dark-yellow rounded text-[10px] lg:text-sm mx-3 w-[32%] text-center px-2 lg:px-4">
       {format(currentMonth, "MMMM ")}
      </div>
      <div className="bg-white py-1 rounded border-gray border text-[10px] lg:text-sm w-[32%] text-center text-black px-2 lg:px-4">
       {format(nextMonth, "MMMM")}
      </div>
     </div>
     <div className="absolute font-semi left-2 calenderText top-[215px]">
      <h1>{t("calendar")}</h1>
     </div>

     <CommonCalendar state={state} onChange={(item: any) => setState([item?.selection])} />
    </Box>
   </div>
  </div>
 )
}
